import useReveal from "../../hooks/useReveal";

export const Reveal = ({ as: Tag = "div", className = "", children, delay = 0, ...rest }) => {
  const ref = useReveal();
  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;
  return (
    <Tag ref={ref} className={`reveal ${className}`} style={style} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
